import index from './pages/index'

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: index
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/login/routes.js